export const SIGN_UP_URL = 'https://identity.temptik.com/Account/Register?domain=temptik';
export const APP_URL = 'https://app.temptik.com';
